// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R8eH","select":"styles_select___GLjr"};